// Static device catalog used to power the "Add Your Devices" drawer during signup.
// Keep entries realistic and current; add more freely — dropdowns fall back to
// "Others" (with manual entry) when a value isn't listed.

export const DEVICE_CATEGORIES = [
  "Desktop", "PC", "Mobile", "Tablet", "Smart TV", "Connected Devices", "Wearable", "Gaming",
];

export const DEVICE_CATALOG = {
  Desktop: {
    Apple: ["iMac 24\"", "iMac Pro", "Mac Studio", "Mac Pro", "Mac mini M2"],
    Dell: ["OptiPlex 7010", "XPS Desktop 8960", "Inspiron Desktop 3910", "Alienware Aurora R16"],
    HP: ["Pavilion Desktop", "Envy Desktop", "OMEN 45L", "EliteDesk 800 G9"],
    Lenovo: ["ThinkCentre M75q", "IdeaCentre 5", "Legion Tower 7i"],
    Acer: ["Aspire TC", "Predator Orion 7000"],
    Asus: ["ROG G22CH", "ExpertCenter D700"],
    Others: [],
  },
  PC: {
    Apple: ["MacBook Air M3", "MacBook Air M2", "MacBook Pro 14 M3", "MacBook Pro 16 M3"],
    Dell: ["XPS 15", "XPS 13", "Latitude 5540", "Inspiron 15", "Precision 5680"],
    HP: ["Spectre x360 14", "EliteBook 840 G10", "Pavilion 15", "OMEN 16", "Envy x360 15"],
    Lenovo: ["ThinkPad X1 Carbon Gen 11", "ThinkPad T14", "Yoga 9i", "Legion 5 Pro", "IdeaPad 5"],
    Asus: ["ZenBook 14 OLED", "ROG Zephyrus G14", "VivoBook 15", "ProArt Studiobook 16"],
    Acer: ["Aspire 5", "Predator Helios 16", "Swift Go 14", "Nitro 5"],
    Microsoft: ["Surface Laptop 5", "Surface Pro 9", "Surface Laptop Studio 2"],
    Others: [],
  },
  Mobile: {
    Apple: ["iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15", "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14", "iPhone 13", "iPhone 13 mini", "iPhone SE (3rd gen)"],
    Samsung: ["Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24", "Galaxy S23 Ultra", "Galaxy S23", "Galaxy Z Fold 5", "Galaxy Z Flip 5", "Galaxy A54", "Galaxy A34"],
    Google: ["Pixel 8 Pro", "Pixel 8", "Pixel 7a", "Pixel 7 Pro", "Pixel 7", "Pixel 6a", "Pixel 6"],
    OnePlus: ["OnePlus 12", "OnePlus 11", "OnePlus Nord 3", "OnePlus 10 Pro", "OnePlus Open"],
    Xiaomi: ["Xiaomi 14 Ultra", "Xiaomi 14", "Xiaomi 13 Pro", "Redmi Note 13 Pro+", "POCO F5"],
    Motorola: ["Edge 40 Pro", "Edge 40", "Moto G84", "Razr 40 Ultra"],
    Nothing: ["Phone (2)", "Phone (1)"],
    Others: [],
  },
  Tablet: {
    Apple: ["iPad Pro 12.9 M2", "iPad Pro 11 M2", "iPad Air (5th gen)", "iPad (10th gen)", "iPad mini (6th gen)"],
    Samsung: ["Galaxy Tab S9 Ultra", "Galaxy Tab S9+", "Galaxy Tab S9", "Galaxy Tab S8", "Galaxy Tab A9+"],
    Microsoft: ["Surface Pro 9", "Surface Pro 8", "Surface Go 4"],
    Lenovo: ["Tab P12 Pro", "Tab P11 Pro", "Tab M10 Plus"],
    Amazon: ["Fire HD 10 (2023)", "Fire Max 11", "Fire HD 8"],
    Xiaomi: ["Pad 6", "Pad 6 Pro"],
    Others: [],
  },
  "Smart TV": {
    Samsung: ["QN90C Neo QLED", "S95C OLED", "The Frame (2023)", "Crystal UHD DU8000"],
    LG: ["G3 OLED evo", "C3 OLED evo", "B3 OLED", "QNED80"],
    Sony: ["Bravia XR A95L OLED", "Bravia XR X90L", "Bravia X85K"],
    TCL: ["QM8 Mini-LED", "Q7", "S4"],
    Hisense: ["U8K", "U7K", "A6H"],
    Vizio: ["M-Series Quantum X", "V-Series 4K"],
    Panasonic: ["MZ2000 OLED", "MZ1500 OLED"],
    Others: [],
  },
  "Connected Devices": {
    Amazon: ["Fire TV Stick 4K Max (2nd gen)", "Fire TV Cube (3rd gen)", "Echo Show 10", "Echo Show 8", "Echo Dot (5th gen)"],
    Google: ["Chromecast with Google TV (4K)", "Chromecast with Google TV (HD)", "Nest Hub Max", "Nest Mini"],
    Apple: ["Apple TV 4K (3rd gen)", "HomePod (2nd gen)", "HomePod mini"],
    Roku: ["Roku Ultra", "Roku Streaming Stick 4K", "Roku Express 4K+"],
    Sonos: ["Sonos One", "Sonos Beam Gen 2", "Sonos Arc", "Sonos Era 300"],
    Others: [],
  },
  Wearable: {
    Apple: ["Apple Watch Ultra 2", "Apple Watch Series 9", "Apple Watch Series 8", "Apple Watch SE (2nd gen)"],
    Samsung: ["Galaxy Watch 6 Classic", "Galaxy Watch 6", "Galaxy Watch 5 Pro", "Galaxy Watch 5"],
    Google: ["Pixel Watch 2", "Pixel Watch"],
    Garmin: ["Fenix 7", "Forerunner 965", "Forerunner 265", "Venu 3", "Instinct 2"],
    Fitbit: ["Charge 6", "Sense 2", "Versa 4", "Inspire 3"],
    Xiaomi: ["Mi Band 8 Pro", "Mi Band 8", "Watch S3"],
    Others: [],
  },
  Gaming: {
    Sony: ["PlayStation 5", "PlayStation 5 Slim", "PlayStation 4 Pro", "PlayStation 4"],
    Microsoft: ["Xbox Series X", "Xbox Series S", "Xbox One X", "Xbox One S"],
    Nintendo: ["Switch OLED", "Switch (v2)", "Switch Lite"],
    Valve: ["Steam Deck OLED", "Steam Deck LCD"],
    Asus: ["ROG Ally Z1 Extreme", "ROG Ally Z1"],
    Meta: ["Quest 3", "Quest 2", "Quest Pro"],
    Others: [],
  },
};

// Platform options per category
export const PLATFORMS_BY_CATEGORY = {
  Desktop: ["Windows", "macOS", "Linux", "Others"],
  PC: ["Windows", "macOS", "Linux", "Others"],
  Mobile: ["iOS", "Android", "Others"],
  Tablet: ["iPadOS", "iOS", "Android", "Windows", "Others"],
  "Smart TV": ["tvOS", "Android TV", "webOS", "Tizen", "Roku OS", "Fire TV OS", "Others"],
  "Connected Devices": ["Fire OS", "Google TV", "tvOS", "Roku OS", "Others"],
  Wearable: ["watchOS", "Wear OS", "Fitbit OS", "Garmin OS", "Others"],
  Gaming: ["PlayStation OS", "Xbox OS", "Nintendo Switch OS", "SteamOS", "Meta Horizon OS", "Others"],
};

// Release version options per platform
export const RELEASE_VERSIONS = {
  iOS: ["18", "17", "16", "15", "14", "13"],
  iPadOS: ["18", "17", "16", "15", "14"],
  Android: ["15", "14", "13", "12", "11", "10"],
  Windows: ["11", "10", "8.1", "7"],
  macOS: ["15 (Sequoia)", "14 (Sonoma)", "13 (Ventura)", "12 (Monterey)", "11 (Big Sur)"],
  Linux: ["Ubuntu 24.04", "Ubuntu 22.04", "Debian 12", "Fedora 40", "Arch Linux"],
  tvOS: ["18", "17", "16", "15"],
  "Android TV": ["14", "13", "12", "11", "10"],
  webOS: ["9", "8", "7", "6"],
  Tizen: ["8.0", "7.0", "6.5", "6.0"],
  "Roku OS": ["13", "12", "11"],
  "Fire TV OS": ["8", "7", "6"],
  "Fire OS": ["8", "7", "6"],
  "Google TV": ["14", "13", "12"],
  watchOS: ["11", "10", "9", "8"],
  "Wear OS": ["5", "4", "3"],
  "Fitbit OS": ["5", "4"],
  "Garmin OS": ["N/A"],
  "PlayStation OS": ["11.x", "10.x", "9.x"],
  "Xbox OS": ["25H1", "24H2", "23H2"],
  "Nintendo Switch OS": ["18.x", "17.x", "16.x"],
  SteamOS: ["3.6", "3.5", "3.4"],
  "Meta Horizon OS": ["v68", "v66", "v64"],
  Others: [],
};

export const OTHERS_LABEL = "Others";
